import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { EntityProfileNavigation } from '../../../../Entity'
import Text from '../../../../Text'

function DocFlowMappingRecipientModalNavigation({
  counterText,
  hasNext,
  hasPrevious,
  isLoading,
  onNext,
  onPrevious,
}) {
  const { t } = useTranslation()

  return hasPrevious || hasNext ? (
    <EntityProfileNavigation
      counterText={counterText}
      disabled={isLoading}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      nextTooltip={t('DocFlow.MappingRecipientModalNextTooltipKey')}
      previousTooltip={t('DocFlow.MappingRecipientModalPreviousTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  ) : (
    <Text isSecondary>{counterText}</Text>
  )
}

export default DocFlowMappingRecipientModalNavigation
